<template>
    <div>
        <br>
        <p style="color: rgb(78, 145, 187); font-weight: bold; font-size: larger; font-family:Microsoft YaHei">
            雇用状況の届出において、業務流れと出せるPDFサンプル</p>
        <el-row :gutter=40>
            <el-col :md=16>
                <div style="width: 55vw;text-align: left;">
                    <el-timeline>
                        <el-timeline-item>
                            <p>雇入れる前</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="雇用保険　事業所">
                                        <template slot="title">
                                            雇用保険　事業所
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns2')">
                                                    雇用保険適用事業所設置届
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険適用事業所設置届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">事業所を設置した日の翌日から起算して10日以内に提出してください</p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empIns8')">
                                                    雇用保険適用除外申請書　（厚生労働大臣への申請）
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険適用除外申請書　（厚生労働大臣への申請）')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                        雇用保険法に規定する求職者給付及び<br>
                                                        就職促進給付の内容を超える給与を<br>
                                                        支給することを規定した法令、条例、規則等を添えること</p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empIns8')">
                                                    雇用保険適用除外申請書　（労働局長への申請）
                                                </el-link>
                                                <el-button type="text" @click="dialogUp('雇用保険適用除外申請書　（労働局長への申請）')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                        <el-timeline-item>
                            <p>雇入れた場合</p>
                            <el-card>
                                <el-collapse accordion>

                                    <el-collapse-item name=" 資格取得届">
                                        <template slot="title">
                                            資格取得届
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns4')">
                                                    雇用保険被保険者資格取得届
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険被保険者資格取得届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>

                                            <li>
                                                <el-link @click="jump('empIns3NewSubmission')">
                                                    雇用保険被保険者資格取得届（連記式）個人別票
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険被保険者資格取得届（連記式）個人別票')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>

                                            <li>
                                                <el-link @click="jump('empIns3NewSummary')">
                                                    雇用保険被保険者資格取得届（連記式）総括票
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険被保険者資格取得届（連記式）総括票')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>

                                            <li>
                                                <el-link @click="jump('empInsInquiry')">
                                                    雇用保険被保険者資格取得届出確認照会票
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険被保険者資格取得届出確認照会票')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">この照会票は、現在働いている（以前働いていた）<br>
                                                        事業所（以下「照会対象事業所」という。）において<br>
                                                        雇用保険の被保険者資格の取得手続きが行われて<br>
                                                        いるかどうかについて、公共職業安定所に対して<br>
                                                        照会、確認する際に用いるものです。
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>

                        <el-timeline-item>
                            <p>雇入れ後</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="再就職">
                                        <template slot="title">
                                            再就職
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns6')">再就職手当支給申請書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('再就職手当支給申請書')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="在留カード番号">
                                        <template slot="title">
                                            在留カード番号
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns13')">
                                                    雇用保険被保険者資格取得・喪失届外国人労働者在留カード番号記載用【別様式】
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険の被保険者である外国人に係る届出')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="個人番号">
                                        <template slot="title">
                                            個人番号
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns5')">個人番号登録・変更届</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('個人番号登録・変更届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empInsMyNumberGroup')">個人番号登録届出書(連記式)個人別票
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('個人番号登録届出書(連記式)個人別票')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empInsMyNumberSummary')">個人番号登録届出書(連記式)総括票
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('個人番号登録届出書(連記式)総括票')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="氏名変更">
                                        <template slot="title">
                                            氏名変更
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns9')">雇用保険被保険者資格喪失届・氏名変更届</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険被保険者資格喪失届・氏名変更届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="各種変更届">
                                        <template slot="title">
                                            各種変更届
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns1')">雇用保険事業主事業所各種変更届</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険事業主事業所各種変更届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="育児給付">
                                        <template slot="title">
                                            育児給付
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empInsChildcareLeave')">
                                                    育児休業給付受給資格確認票・（初回）育児休業給付金支給申請書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text"
                                                    @click="dialogUp('育児休業給付受給資格確認票・（初回）育児休業給付金支給申請書')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empInsPaymentOption')">払渡希望金融機関指定・変更届</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('払渡希望金融機関指定・変更届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empInsRemoveBenefit')">未支給失業等給付請求書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('未支給失業等給付請求書')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="介護給付">
                                        <template slot="title">
                                            介護給付
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empInsNursingLeave')"> 介護休業給付金支給申請書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('介護休業給付金支給申請書')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empInsPaymentOption')">払渡希望金融機関指定・変更届</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('払渡希望金融機関指定・変更届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empInsRemoveBenefit')">未支給失業等給付請求書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('未支給失業等給付請求書')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="高齢給付">
                                        <template slot="title">
                                            高齢給付
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empInsElderly')">
                                                    高年齢雇用継続給付受給資格確認票・（初回）高年齢雇用継続給付支給申請書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text"
                                                    @click="dialogUp('高年齢雇用継続給付受給資格確認票・（初回）高年齢雇用継続給付支給申請書')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empInsPaymentOption')">払渡希望金融機関指定・変更届</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('払渡希望金融機関指定・変更届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                            <li>
                                                <el-link @click="jump('empInsRemoveBenefit')">未支給失業等給付請求書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('未支給失業等給付請求書')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="事務等代理人選任・解任">
                                        <template slot="title">
                                            事務等代理人選任・解任
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empInsAuthorityLetter')">
                                                    雇用保険被保険者関係届出-事務等代理人選任・解任届
                                                </el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険被保険者関係届出事務等代理人選任・解任届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>

                        <el-timeline-item>
                            <p>離職した場合</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="離職票">
                                        <template slot="title">
                                            離職票
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns3')">雇用保険被保険者離職票再交付申請書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険被保険者離職票再交付申請書')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>

                                    <el-collapse-item name="転勤届">
                                        <template slot="title">
                                            転勤届
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns12')">雇用保険被保険者転勤届</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険被保険者転勤届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>

                        <el-timeline-item>
                            <p>雇用保険に加入しないの場合</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="外国人雇用状況届">
                                        <template slot="title">
                                            外国人雇用状況届
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns14')">雇入れ・離職に係る外国人雇用状況届出書</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険の被保険者ではない外国人に係る届出')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">雇入れた外国人労働者を雇用保険に加入しないの場合<br>
                                                        「雇用保険被保険者資格取得・喪失届」を提出しない<br>
                                                        ために出す届です
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>

                        <el-timeline-item>
                            <p>事業所廃止の場合</p>
                            <el-card>
                                <el-collapse accordion>
                                    <el-collapse-item name="雇用保険適用事業所廃止">
                                        <template slot="title">
                                            雇用保険適用事業所廃止
                                        </template>
                                        <ul>
                                            <li>
                                                <el-link @click="jump('empIns7')">雇用保険適用事業所廃止届</el-link>
                                                &emsp;&emsp;
                                                <el-button type="text" @click="dialogUp('雇用保険適用事業所廃止届')">
                                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                                                &emsp13;
                                                <el-popover placement="top-start">
                                                    <p class="popover_note">
                                                    </p>
                                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                                    </el-button>
                                                </el-popover>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>
                            </el-card>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </el-col>
            <el-col :md=8>
                <div style="text-align: left; margin-top: 6rem;">
                    <el-card class="note_card">
                        <p style="margin-top: 0%; color: rgb(72, 101, 119); 
                        font-weight: bold; font-size: medium; 
                        font-family:Microsoft YaHei">外国人を雇用する事業主の方へ雇用保険について</p>
                        <ol>
                            <li>外国人の雇用状況を適切に届け出てください
                                <el-popover placement="top-start">
                                    <p class="popover_note">外国人の雇入れおよび離職の際には、 <br>
                                        その氏名、在留資格などをハローワークに<br>
                                        届け出てください。ハローワークでは、<br>
                                        届出に基づき、雇用環境の改善に向けて、<br>
                                        事業主の方への助言や指導、離職した<br>
                                        外国人への再就職支援を行います。<br>
                                        また、届出に当たり、事業主が雇い入れる<br>
                                        外国人の在留資格などを確認する必要 <br>
                                        があるため、不法就労の防止につながります。</p>
                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                    </el-button>
                                </el-popover>
                            </li>
                            <li>外国人の雇用管理を適切に行ってください
                                <el-popover placement="top-start">
                                    <p class="popover_note">事業主が遵守すべき法令や、努めるべき<br>
                                        雇用管理の内容などを盛り込んだ「外国<br>
                                        人労働者の雇用管理の改善等に関して<br>
                                        事業主が適切に対処するための指針」を<br>
                                        定めています<br>
                                        （雇用対策法に基づき平成19年10月1日施行）。<br>
                                        この指針に沿って、職場環境の改善や再就職の<br>
                                        支援に取り組んでください。</p>
                                    <el-button type="text" icon="el-icon-info" slot="reference">
                                    </el-button>
                                </el-popover>
                            </li>
                            <li>
                                令和２年３月から外国人雇用状況の届出において、在留カード番号の記載が必要となります。
                                &emsp;
                                <el-button type="text" @click="dialogNoteUp('在留カード番号の記載')">
                                    <i class="fa fa-file-pdf-o"></i> </el-button>
                            </li>
                        </ol>
                        <p>詳しくは
                            <el-link
                                href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/jigyounushi/page11.html"
                                target="_blank" style="font-size: small;">
                                厚生労働省の外国人の雇用ページ
                            </el-link>をご覧ください。</p>
                        <p>外国人雇用はルールを守って適正に &emsp;
                            <el-button type="text" @click="dialogNoteUp('外国人雇用はルールを守って適正')">
                                <i class="fa fa-file-pdf-o"></i> </el-button>
                        </p>
                    </el-card>

                    <br>
                    <el-card class="note_card">
                        <p style="margin-top: 0%; color: rgb(72, 101, 119); 
                        font-weight: bold; font-size: medium; 
                        font-family:Microsoft YaHei">雇用保険適用事業所設置・廃止について</p>
                        <ol>
                            <li>事業所を設置した日の翌日から起算して10日以内に提出してください。</li>
                            <li>営業許可証、登記事項証明書その他記載内容を確認することができる書類を持参してください。</li>
                        </ol>
                    </el-card>
                    <br>
                    <el-card class="note_card">
                        <p style="margin-top: 0%; color: rgb(72, 101, 119); 
                        font-weight: bold; font-size: medium; 
                        font-family:Microsoft YaHei">雇用保険被保険者資格取得について</p>
                        <ol>
                            <li>雇用保険の資格取得年月日の属する月の翌月10日までに提出してください。</li>
                            <li>賃金台帳、労働者名簿、出勤簿その他記載内容を確認できる書類を持参していただく場合があります。</li>
                        </ol>
                    </el-card>
                    <br>

                    <el-card class="note_card">
                        <p style="margin-top: 0%; color: rgb(72, 101, 119); 
                        font-weight: bold; font-size: medium; 
                        font-family:Microsoft YaHei">雇用保険被保険者離職票再交付申請について</p>
                        <ol>
                            <li>離職票を損傷したことにより再交付の申請をする者は、損傷した離職票を公共職業安定所に提出すること。</li>
                            <li>申請者が離職者本人の場合は、運転免許証又は住民票の写し等本人確認の出来る書類を添付すること。</li>
                        </ol>
                    </el-card>
                </div>
            </el-col>
        </el-row>

        <el-dialog :visible.sync="dialogVisible" width=60%>
            <p style="margin-top: 0%; color: rgb(72, 101, 119); 
                font-weight: bold; font-size: x-large; 
                font-family:Microsoft YaHei">
                PDFサンプル</p>
            <div>
                <!-- <el-button @click="$refs.sampleDocument.print()">download</el-button> -->
                <pdf ref="sampleDocument" :src="pdfSrc" v-for="i in numPages" :key="i" :page="i">
                </pdf>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogNote" width=60%>
            <p style="margin-top: 0%; color: rgb(72, 101, 119); 
                font-weight: bold; font-size: x-large; 
                font-family:Microsoft YaHei">
                注意するもの</p>
            <div>
                <pdf ref="sampleDocument" :src="pdfSrc" v-for="i in numPages" :key="i" :page="i">
                </pdf>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import pdf from 'vue-pdf'
    export default {
        components: {
            pdf
        },
        data() {
            return {
                dialogVisible: false,
                dialogNote: false,
                src: "",
                pdfSrc: "",
                numPages: 0,
            };
        },
        methods: {
            jump(path) {
                this.$router.push(path);
            },

            dialogUp(fileName) {
                this.src = "/pdfSample/" + fileName + ".pdf"

                // let loadingTask = pdf.createLoadingTask(this.year + "/pdfSample/" + fileName +  ".pdf")
                let loadingTask = pdf.createLoadingTask("/pdfSample/" + fileName + ".pdf")

                this.pdfSrc = loadingTask
                this.pdfSrc.promise.then(pdf => {
                    this.numPages = pdf.numPages;
                });
                this.dialogVisible = true
                // window.open(this.src)
            },
            dialogNoteUp(fileName) {
                this.src = "/pdfSample/" + fileName + ".pdf"

                let loadingTask = pdf.createLoadingTask("/pdfSample/" + fileName + ".pdf")
                this.pdfSrc = loadingTask
                this.pdfSrc.promise.then(pdf => {
                    this.numPages = pdf.numPages;
                });
                this.dialogNote = true
                // window.open(this.src)
            }
        }
    };
</script>

<style scoped>
    .note_card {
        background-color: #51d1ff1c;
        font-size: small;
    }

    .popover_note {
        font-size: smaller;
        color: #4d4d4d;

    }
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpInsSteps.vue